const cam2_noite_f = require('./cam2_noite_f.webp');
export default [cam2_noite_f];
